import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { environment } from '../../environments/environment';

@Injectable()
export class BaseService {

  public baseUrl: string;

  constructor(public http: HttpClient) {
    this.baseUrl = environment.apiUrl;
  }

  getHeader(contentType = 'application/x-www-form-urlencoded'): HttpHeaders {
    const token = sessionStorage.getItem('token');
    if (token) {
      const headerOptions = {
        'Authorization': token,
        'Content-Type': contentType,
        'Accept': 'application/json',
        'X-Device-Context': 'asap_authorized_access'
      };
      return new HttpHeaders(headerOptions);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/services/base.service.ts